export const ANNIMATION_SPEED = 0.5;
export const POLLING_INTERVAL = 30000;
